<template>
    <div id="content">
        <div class="inner">
            <h1 v-translate>Přidat typ zařízení</h1>
        </div>

        <div class="responsiveTabs">

            <ul class="tabs">
                <li class="clickable" :class="{'r-tabs-state-active' : this.$route.name === 'deviceTypeNewDescription'}"><a class="clickable" @click.stop="openRoute('deviceTypeNew')" v-translate>Vlastnosti</a></li>
                <li class="clickable" :class="{'r-tabs-state-active' : this.$route.name === 'deviceTypeNewStreams'}"><a @click.stop="openRoute('deviceTypeNewStreams')" v-translate>Profily streamů</a></li>
            </ul>

            <router-view
                :entity="entity"
                :deviceGroups="this.deviceGroups"
                :protocols="protocols"
                :codecs="codecs"
                :streamProfiles="streamProfiles"
                :advertisingProviders="advertisingProviders"
                :is-editable="true"
            />

            <section class="buttons">
                <p>
                    <a class="btn btn_back btn_seznam" @click.stop="showDeviceTypeList" v-translate>Seznam typů zařízení</a>
                    <input type="submit" :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="createEntity()">
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import deviceTypes from "@/components/views/deviceTypes/mixins/deviceTypes"
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "DeviceTypeNew",
    components: {},
    data () {
        return {
            codecs: [],
            deviceGroups: [],
            protocols: [],
            streamProfiles: [],
            advertisingProviders: [],
        }
    },
    mixins: [detailActions, deviceTypes],
    created(DeviceTypeService) {
        this.entityService = DeviceTypeService
        this.getDependency();
    },
    methods: {
        _processDetailErrorMessage(error) {
            return this.processErrorMessage(error)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/DeviceTypeNew.vue